<template>
  <!-- 常見問題 -->
  <div class="CommonProblem">
    <!-- 首頁圖 -->
    <div class="banner">
      <h1>{{ $t("nav.q_a") }}</h1>
    </div>
    <!-- 主要內容 -->
    <div class="content-container">
      <!-- 標題 -->
      <div class="title">
        <span>{{ $t("q_a.contant_title") }}</span>
      </div>
      <!-- 內容 -->
      <div
        class="content-box"
        v-for="(item, index) in problemData.questions"
        :key="index"
      >
        <div
          @click="changeStatus(index)"
          :class="[
            'ellipse-container',
            { evenDomColor: (index + 1) % 2 === 0 },
          ]"
        >
          <span class="num-tips">{{ index + 1 }}</span>
          <!-- 標題提示 -->
          <span class="text-tips">{{ item.tips }}</span>
          <!-- 切換按鈕 -->
          <div class="more-btn">
            <span></span>
            <span v-show="item.expandStatus"></span>
          </div>
        </div>
        <!-- 更多內容 -->
        <div v-show="!item.expandStatus" ref="content" class="content">
          <p v-if="item.answer" class="content-item1" v-html="item.answer" @click="$t('msg.hello') === 'hello' & index=== 1 ? gotoMenu('home', '/Home') : ''">
          </p>
          <div v-if='index==7'>
            <table id='question8'>
              <tr v-for='(n, i) in 4' :key='i'>
                <td v-if='i!=0'>{{ i }}</td>
                <td v-else></td>
                <td>
                  {{ $t('home.submit_deadline'+i)}}
                </td>
                <td>
                  {{ $t('home.release_month'+i)}}
                </td>
              </tr>
            </table>
            <div v-html='$t("q_a.question8_content")'></div>
          </div>
          <ul v-if="item.contentItem2" class="content-item2">
            <span>{{ item.contentItem2.title || "" }}</span>
            <li v-for="item1 in item.contentItem2.lis" :key="item1">
              <i class="list-mark"></i>
              {{ item1 }}
            </li>
          </ul>
          <div v-if="item.contentItem3" class="content-item3">
            <div>{{ item.contentItem3.title }}</div>
            <div>
              {{ item.contentItem3.content }}
            </div>
          </div>
          <p
            v-if="item.contentItem4"
            class="content-item4"
            v-html="item.contentItem4"
          ></p>
        </div>
        <!-- 分隔符 -->
        <div class="separate"></div>
      </div>
      <b class="bom-tit" v-html="problemData.other_questions"></b>
      <!-- <b class="bom-tit">{{problemData.hot_line}}</b> -->
    </div>
  </div>
</template>

<script>
export default {
  name: "CommonProblem",
  data() {
    return {
      mainData: this.$t("q_a.questions"),
    };
  },
  components: {},
  methods: {
    // 修改顯示隱藏狀態
    changeStatus(e) {
      this.$nextTick(function() {
        this.mainData[e].expandStatus = !this.mainData[e].expandStatus;
      });
    },
    // 跳转页面
    gotoMenu(selectNav, path) {
      // chrome
      document.body.scrollTop = 0;
      // firefox
      document.documentElement.scrollTop = 0;
      // safari
      window.pageYOffset = 0;
      this.resetSetItem("selectNav", selectNav);
      this.$router.push({ path: path });
    },
  },
  computed: {
    problemData: function() {
      return this.$t("q_a");
    },
  },
};
</script>

<style scoped lang="scss">
#question8 td {
  text-align: center;
  border: 1px solid black;
}
#question8 {
  border-collapse: collapse;
  width: 80%;
  margin: 20px auto;
}
#question8 tr td:first-child {
  width: 10%;
}
#question8 tr td:nth-child(2) {
  width: 45%;
}
#question8 tr td:last-child {
  width: 45%;
}
.CommonProblem {
  .banner {
    background-image: url("../assets/img/problem/qna.jpg");
  }
  .content-container {
    max-width: 940px;
    .title {
      margin-bottom: 4vw;
    }
    .content-box {
      margin-top: 25px;
      .ellipse-container {
        margin: 0 auto;
        position: relative;
        background: #85c357;
        border-radius: 50px;
        color: white;
        padding: 15px 0;
        .num-tips {
          position: absolute;
          left: 1%;
          top: -35%;
          display: flex;
          width: 40px;
          height: 40px;
          border: solid 2px white;
          border-radius: 50%;
          background: inherit;
          justify-content: center;
          align-items: center;
        }
        .text-tips {
          padding-left: 60px;
          max-width: 80%;
          overflow: hidden;
          display: inline-block;
          max-height: 20px;
          overflow: hidden;
        }
        .more-btn {
          position: absolute;
          width: 20px;
          height: 16px;
          right: 2.2vw;
          top: 50%;
          float: right;
          cursor: pointer;
          transform: translateY(-50%);
          span {
            display: inline-block;
            width: 20px;
            height: 2px;
            border-radius: 5px;
            background: white;
            position: absolute;
            left: 0;
            top: 6px;
            &:last-child {
              transform: rotate(90deg);
            }
          }
        }
      }
      .content {
        // position: relative;
        left: 0;
        top: -2vw;
        border-radius: 0 0 50px 50px;
        padding: 0vw 5vw 2vw;
        box-sizing: border-box;
        z-index: -1;
        border: solid 1px #ebebeb;
        line-height: 30px;    
        border-top: 0;
        .content-item1 {
          padding-top: 2vw;
        }
        .content-item2 {
          position: relative;
          text-indent: 1.8vw;
          margin-bottom: 2.4vw;
          & > li {
            position: relative;
            .list-mark {
              height: 16px;
              top: 5px;
            }
          }
          & > span {
            font-weight: bold;
          }
        }
        .content-item3 {
          & > div:first-child {
            font-weight: bold;
          }
        }
      }
      .evenDomColor {
        background: #229fd8;
      }
    }
    .bom-tit {
      display: block;
      margin: 20px 0;
    }
    .separate {
      width: 90%;
      height: 2px;
      background: #f0f3f2;
      margin: 2.2vw auto 1.3vw;
    }
  }
}
@media (max-width: 768px) {
  .CommonProblem {
    .content-container {
      .content-box {
        padding: 0;
        .ellipse-container {
          .num-tips {
            width: 30px;
            height: 30px;
            left: 2%;
            top: -25%;
          }
          .text-tips {
            padding-left: 35px;
          }
          .more-btn {
            width: 15px;
            height: 15px;

            span {
              width: 15px;
            }
          }
        }
        .content {
          font-size: 14px;
          line-height: 24px;
          border-radius: 0 0 20px 20px;
          .content-item2 {
            text-indent: 0;
            padding-left: 2.5vw;
            & > li {
              .list-mark {
                left: -10px;
              }
            }
          }
        }
      }
    }
  }
}
</style>
